// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__+Y9YH","icon":"CloseButton_icon__4XqS-"};